<template>
  <div>
    <!-- Основная информация -->

    <div class="mb-10">
      <template v-if="isUL">
        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right">Наименование:</v-col>
          <v-col class="font font--p" cols="12" sm="9">
            {{ company ? company.name : "" }}
          </v-col>
        </v-row>

        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right">ИНН:</v-col>
          <v-col class="font font--p" cols="12" sm="9">
            {{ company ? company.inn : "" }}
          </v-col>
        </v-row>

        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right"
          >{{ company && company.ogrn && company.ogrn.length === 15 ? "ОГРНИП" : "ОГРН" }}:
          </v-col
          >
          <v-col class="font font--p" cols="12" sm="9">
            {{ company ? company.ogrn : "" }}
          </v-col>
        </v-row>
      </template>

      <v-row v-else class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right">ИНН:</v-col>
        <v-col class="font font--p" cols="12" sm="9">
          {{ inn }}
        </v-col>
      </v-row>

      <v-form ref="bankForm" v-model="bankDetailsValid">
        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right"
          >БИК:<span v-if="!bic" class="profile-is-not-filled ml-sm-2"></span
          ></v-col>
          <v-col cols="12" sm="9">
            <BankSearch v-model="localBank" dense :rules="[rules.required('')]" />
          </v-col>
        </v-row>

        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right"
          >Счёт №<span v-if="!acc" class="profile-is-not-filled ml-sm-2"></span
          ></v-col>
          <v-col cols="12" sm="9">
            <!-- TODO: показывать ошибки, для этого надо поправить верстку, сейчас съезжает -->
            <v-text-field
              hide-details
              :rules="[rules.required(''), rules.acc20, rules.acc]"
              v-mask="'##### ### # #### #######'"
              v-model="localAcc"
              dense
              single-line
              label="Введите номер счёта получателя"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- НДС  -->

        <v-row class="mb-3" dense align="center">
          <v-col cols="12" sm="3" class="font font--color_light text-left text-sm-right"
          >НДС:</v-col>
          <v-col cols="12" sm="9">
            <v-select
              no-data-text="Без НДС"
              ref="nds"
              :value="localNds"
              :items="vatOptions"
              clearable
              hide-details
              hide-selected
              item-text="text"
              outlined
              single-line
              return-object
              v-model="localNds"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>

      <v-row v-if="detailsChanged" class="mt-6" dense align="center">
        <v-col offset="0" offset-sm="3" cols="12">
          <v-btn class="mr-3" :disabled="!detailsValid" color="primary" @click="updateBankDetails">Сохранить</v-btn>
          <v-btn text @click="resetChangeDetails">Отмена</v-btn>
        </v-col>
      </v-row>
    </div>

    <!-- Налогообложение -->

    <div v-if="isUL" class="mb-10">
      <div class="d-flex req-title mb-6">
        <h3 class="font font--h3">
          Выберите систему налогообложения <span v-if="!tax_type" class="profile-is-not-filled ml-sm-2"></span>
        </h3>
        <div class="flex-grow-1"></div>
      </div>
      <v-select
        hide-details
        :menu-props="{ bottom: true, offsetY: true }"
        single-line
        dense
        style="margin-bottom: 10px"
        v-model="localTaxType"
        :items="tax_types"
        label="Система налогообложения"
        outlined
      ></v-select>
      <div v-if="localTaxType !== tax_type" class="mt-8">
        <v-btn class="mr-3" color="primary" @click="updateTaxType">Сохранить</v-btn>
        <v-btn text @click="resetChangeTaxType">Отмена</v-btn>
      </div>
    </div>

    <div v-if="extraReqIsNotFilled" class="mb-10">
      <div class="d-flex req-title mb-6">
        <h3 class="font font--h3">
          Доп. информация <span class="profile-is-not-filled ml-sm-2"></span>
        </h3>
        <div class="flex-grow-1"></div>
      </div>
      <v-layout column>
        <v-form ref="extraRequisitesForm" v-model="extraRequisitesValid">
          <v-row align-center>
            <v-col sm="3" cols="12">
              <span class="d-flex align-center font font--color_light">
                Город нахождения <span class="profile-is-not-filled"></span>
              </span>
            </v-col>
            <v-col sm="9" cols="12">
              <city-search v-model="localCity" dense :rules="[rules.required('')]" />
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="3" cols="12">
              <span class="d-flex align-center font font--color_light">Ссылки на ресурсы</span>
            </v-col>
            <v-col sm="9" cols="12">
              <v-textarea v-model="localLinks" counter="2048" outlined no-resize />
            </v-col>
          </v-row>
        </v-form>

        <v-row v-if="localCity || localLinks" class="mt-6" dense align="center">
          <v-col offset="0" offset-sm="3" cols="12">
            <v-btn class="mr-3" :disabled="!extraRequisitesValid" color="primary" @click="updateExtraRequisites">Сохранить</v-btn>
            <v-btn text @click="resetExtraRequisites">Отмена</v-btn>
          </v-col>
        </v-row>
      </v-layout>
    </div>

    <!-- Модель вознаграждения -->

    <div class="mb-10" v-if="isActualTarif">
      <div class="d-flex req-title">
        <h3 class="font font--h3">
          Модель вознаграждения
          <span v-if="!reward_type" class="profile-is-not-filled ml-sm-2"></span>
        </h3>
        <div class="flex-grow-1"></div>
      </div>

      <v-radio-group :disabled="!!rewardTypeUnchangeableUntil" v-model="localRewardType" row required>
        <v-radio v-for="reward in rewardTypes" color="#88BD1F" :key="reward.value" :label="reward.name"
                 :value="reward.value" class="mb-sm-3" />
      </v-radio-group>
      <div class="d-flex font font--note font--color_light mb-sm-0 mb-2">
        <div style="margin-right: 10px">
          <v-icon size="18px">{{ "mdi-information-outline" }}</v-icon>
        </div>
        <div v-if="!rewardTypeUnchangeableUntil">
          <div v-if="localRewardType === 'P'">
            Мы заплатим
            <span v-if="isUL">От 3 000 до 5 000 ₽ за каждого привлечённого клиента.{{ " " }}</span>
            <span v-if="isFL">От 2 300 до 4 000 ₽ за каждого привлечённого клиента. {{ " " }}</span>
            <a class="text-link" target="_blank" href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf"
            >Ознакомиться</a
            >
            с полным описанием моделей вознаграждения.
          </div>
          <div v-if="localRewardType === 'F'">
            Мы заплатим
            <span v-if="isUL"
            >2000 руб. за каждого приведённого клиента + до 13% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 7% от комиссий их клиентов.</span
            >
            <span v-if="isFL"
            >1600 руб. за каждого приведённого клиента + до 10% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 5,5% от комиссий их клиентов.</span
            >{{ " " }}
            <a class="text-link" target="_blank" href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf"
            >Ознакомиться</a
            >
            с полным описанием моделей вознаграждения.
          </div>
          <div class="mt-2">
            Если вы измените модель вознаграждения сейчас, то выбранный вариант будет применён первого числа следующего
            месяца
          </div>
        </div>
        <div v-else>Смена будет доступна с {{ rewardTypeUnchangeableUntil }}</div>
      </div>

      <div v-if="rewardTypeChanged" class="mt-8">
        <v-btn class="mr-3" color="primary" @click="updateRewardType">Сохранить</v-btn>
        <v-btn text @click="resetRewardType">Отмена</v-btn>
      </div>
    </div>

    <!-- Загрузка документов -->

    <div class="mb-10" v-if="showDocSection">
      <div class="d-flex req-title mb-3">
        <h3 class="font font--h3">
          {{ isUL ? "Загрузите фото паспорта директора" : "Загрузите фото паспорта и СНИЛС" }}
          <span v-if="!isFilesAdded" class="profile-is-not-filled ml-sm-2"></span>
        </h3>
        <div class="flex-grow-1"></div>
      </div>

      <v-row class="mb-5">
        <v-col>
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="passport_1"
            label="Первый разворот паспорта"
            name="passport_1"
          />
        </v-col>
        <v-col>
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="passport_2"
            label="Страница со штампом регистрации"
            name="passport_2"
          />
        </v-col>
        <v-col v-if="isFL">
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="snils_file"
            label="Сторона с номером СНИЛС"
            name="snils"
          />
        </v-col>
      </v-row>
      <v-btn v-if="isFilesAdded" color="primary" @click="sendFiles">Отправить</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { mask } from "vue-the-mask";

import { update, sendFiles } from "@/api";
import { validateAcc } from "@/utils/helpers";
import { format } from "date-fns";

import BankSearch from "@/components/common/BankSearch.vue";
import CitySearch from "@/components/common/CitySearch.vue";
import { rewardTypes } from "@/utils/rewardTypes";

export default {
  directives: { mask },

  components: {
    BankSearch,
    CitySearch
  },

  data() {
    return {
      vatOptions: [
        { text: "Без НДС", value: null },
        { text: "0%", value: 0 },
        { text: "5%", value: 5 },
        { text: "7%", value: 7 },
        { text: "10%", value: 10 },
        { text: "20%", value: 20 },
      ],
      rules: {
        required: (msg) => (v) => !!v || msg,
        acc20: (v) =>
          (typeof v === "string" && v.replace(/\D/g, "").length === 20) || "Счёт получателя должен содержать 20 цифр",
        acc: (v) =>
          !this.localBank
            ? "Сначала введите БИК"
            : (typeof v === "string" && validateAcc(v.replace(/\D/g, ""), this.localBank.bic)) ||
            "Неверная контрольная цифра. Внимательно проверьте БИК и номер счёта",
      },
      tax_types: [
        { text: "ОСН — общая система налогообложения", value: "osn" },
        { text: "УСН — упрощенная система налогообложения", value: "usn" },
        { text: "ПСН — патентная система налогообложения", value: "psn" },
        { text: "ЕНВД — единый налог на вмененный доход", value: "envd" },
        { text: "ЕСХН — единый сельскохозяйственный налог", value: "eshn" },
      ],
      localRewardType: null,
      localAcc: "",
      localBank: null,
      localCity: undefined,
      localLinks: undefined,
      localTaxType: "osn",
      localNds: null,
      bankDetailsValid: false,
      extraRequisitesValid: false,
      rewardTypes: rewardTypes,
    };
  },

  computed: {
    ...mapState("profile", [
      "company",
      "acc",
      "files",
      "inn",
      "bank",
      "profile_id",
      "reward_type",
      "unchangeable_fields",
      "vat"
    ]),
    ...mapGetters("profile", ["bic", "isFL", "isUL", "isFilesAdded", "isActualTarif", "extraReqIsNotFilled"]),

    rewardTypeUnchangeableUntil() {
      if (this.unchangeable_fields && Array.isArray(this.unchangeable_fields)) {
        const dateText = this.unchangeable_fields.find((f) => f.name === "reward_type")?.until_to;
        if (dateText) {
          return format(new Date(dateText), "dd.MM.yyyy");
        }
      }
      return null;
    },

    detailsValid() {
      return this.bankDetailsValid;
    },

    detailsChanged() {
      const accChanged =
        (this.localAccCleared && this.localAccCleared !== this.acc) || (!this.localAccCleared && !!this.acc);
      const localBic = this.localBank ? this.localBank.bic : "";
      const bic = this.bank ? this.bank.bic : "";
      const bicChanged = (localBic && localBic !== bic) || (!localBic && !!bic);
      const vatChanged = this.localNds?.value !== this.vat;

      return accChanged || bicChanged || vatChanged;
    },

    localAccCleared() {
      return this.localAcc ? this.localAcc.replace(/\D/g, "") : "";
    },

    rewardTypeChanged() {
      return this.reward_type !== this.localRewardType;
    },

    // Все нужные файлы загружены
    isAllFilesLoaded() {
      return (
        Array.isArray(this.files) && (this.isFL ? this.files.length >= 3 : this.isUL ? this.files.length >= 2 : false)
      );
    },

    // Все загруженные файлы отправлены
    isAllFilesSended() {
      return Array.isArray(this.files) && this.files.length > 0 && this.files.every((file) => file.sended === true);
    },

    // Есть отклоненные файлы
    hasDeclinedFiles() {
      return Array.isArray(this.files) && this.files.some((file) => file.is_approved === false);
    },

    showDocSection() {
      return !this.files || !this.isAllFilesLoaded || !this.isAllFilesSended || this.hasDeclinedFiles;
    },

    passport_1() {
      return (Array.isArray(this.files) && this.files.find((file) => file.doc_type === "passport_1")) || null;
    },

    passport_2() {
      return (Array.isArray(this.files) && this.files.find((file) => file.doc_type === "passport_2")) || null;
    },

    snils_file() {
      return (Array.isArray(this.files) && this.files.find((file) => file.doc_type === "snils")) || null;
    },

    tax_type: {
      get() {
        return this.$store.state.profile.tax_type;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "tax_type", value });
      },
    },
  },

  watch: {
    localBank() {
      this.$refs.bankForm.validate();
    },
  },

  methods: {
    ...mapMutations({
      setProfileData: "profile/set",
    }),

    resetChangeTaxType() {
      this.localTaxType = this.tax_type;
    },

    async updateTaxType() {
      const res = await this.$store.dispatch("profile/updateProfile", {
        tax_type: this.localTaxType,
      });
      if (res) {
        this.setProfileData({ type: "tax_type", value: this.localTaxType });
      }
    },

    resetRewardType() {
      this.localRewardType = this.reward_type;
    },

    async updateRewardType() {
      await this.$store.dispatch("profile/updateProfile", {
        reward_type: this.localRewardType,
      });
    },

    resetChangeDetails() {
      this.localBank = this.bank;
      this.localAcc = this.acc;
      this.setLocalNds();
      this.$refs.bankForm.resetValidation();
    },

    resetExtraRequisites() {
      this.$refs.extraRequisitesForm.reset();
    },

    async updateBankDetails() {
      const data = { bic: this.localBank.bic, acc: this.localAccCleared, vat: this.localNds.value };
      const res = await this.$store.dispatch("profile/updateProfile", data);
      if (res) {
        this.setProfileData({ type: "bank", value: this.localBank });
        this.setProfileData({ type: "acc", value: this.localAccCleared });
        this.setProfileData({ type: "vat", value: this.localNds.value });
      }
    },

    async updateExtraRequisites() {
      await this.$store.dispatch("profile/updateProfile", {
        extra_requisites: {
          city: this.localCity?.city_name,
          links: this.localLinks
        }
      });
    },

    addFile(data) {
      data.oid = this.profile_id;
      this.$store.dispatch("profile/addFile", data);
    },

    async sendFiles() {
      const res = await sendFiles();
      if (res) {
        this.$store.dispatch("profile/get");
      }
    },

    setLocalNds() {
      this.localNds = this.vatOptions.find(option => option.value == this.vat) || this.vatOptions[0];
    },
  },

  mounted() {
    this.localBank = this.bank;
    this.localAcc = this.acc;
    this.localTaxType = this.tax_type;
    this.localRewardType = this.reward_type;
    this.setLocalNds();
  },
};
</script>

<style lang="scss" scoped>
.req-title {
  & > * {
    padding-bottom: 8px;
    border-bottom: 2px rgba(0, 0, 0, 0.0947973) solid;
  }

  h3 {
    border-bottom-color: #4971d0;
  }
}

.paragraph-info {
  text-align: center;
  margin: 16px;
}
</style>
